<mbs-wizard
  #wizard
  [attr.data-e2e]="e2eLocators.main"
  [backButton]="{
    text: 'shared:buttons.back' | i18next,
    e2eLocator: e2eLocators.backBtn
  }"
  [canCloseWithoutSave]="true"
  [cover]="cover()"
  [loading]="isLoading()"
  [nextButton]="{
    loading: isNextButtonLoading(),
    text: 'shared:buttons.next' | i18next,
    e2eLocator: e2eLocators.nextBtn
  }"
  [saveButton]="{
    e2eLocator: e2eLocators.saveBtn,
    text: 'shared:buttons.save' | i18next
  }"
  [scrollableStepContent]="true"
  [stepsOrientation]="'vertical'"
  [title]="(mode === creationMode.Create ? 'storages:addStorageAccountWizard.create' : 'storages:addStorageAccountWizard.edit') | i18next"
  (save)="onSaveButtonClick()"
  (stepSelected)="onStepSelected($event)">
  @if (mode === creationMode.Create) {
    <mbs-wizard-step
      [e2eLocator]="e2eLocators.selectStorageTab"
      [title]="'storages:addStorageAccountWizard.selectStorageStep.title' | i18next"
      [valid]="selectStorageStepValid()">
      <mbs-select-storage-step
        [error]="selectStorageError()"
        [storages]="availableStorages"
        [wizardForm]="wizardForm"></mbs-select-storage-step>
    </mbs-wizard-step>
  }

  <mbs-wizard-step
    [e2eLocator]="e2eLocators.inputCredentialsTab"
    [title]="'storages:addStorageAccountWizard.inputCredentialsStep.title' | i18next"
    [valid]="useExistingAccountControl.value ? existingAccountLoaded() : isCredentialsValid()"
    (nextButtonClicked)="validateCredentials()">
    <mbs-storage-account-step
      [accountDisplayName]="accountDisplayName"
      [canSelectSource]="canSelectSource()"
      [error]="credentialsError"
      [existingAccounts]="existingAccounts()"
      [existingLoaded]="existingAccountsLoaded()"
      [existingLoading]="existingAccountsLoading()"
      [form]="credentialsInfo"
      [helpLinkValue]="helpLink"
      [isNativeMultipartControlShown]="isNativeMultipartControlShown()"
      [mode]="mode"
      [selectedAccountId]="selectedAccountId()"
      [storageAccountControl]="pickedAccount"
      [storageType]="wizardForm.value.storageType"
      [useExistingControl]="useExistingAccountControl"
      (loadMoreExisting)="loadMoreExistingAccounts()"></mbs-storage-account-step>
  </mbs-wizard-step>

  @if (!companyIds?.length && (mode === creationMode.Edit || (selectStorageStepValid() && !useExistingAccountControl.value))) {
    <mbs-wizard-step
      [title]="companiesStepTitle"
      [valid]="companiesStepValid"
      (nextButtonClicked)="submitWizardCompanies()">
      <mbs-companies-step
        [companiesControl]="wizardCompaniesControl"
        [companiesData]="wizardCompanies()"
        [companiesLocked]="!!lockedCompany"
        [loading]="wizardCompaniesLoading()"
        [restrictControl]="restrictByCompaniesControl"
        [selectedCompanyIds]="preselectedCompanyIds()"></mbs-companies-step>
    </mbs-wizard-step>
  }

  @if (mode === creationMode.Create) {
    <mbs-wizard-step
      [e2eLocator]="e2eLocators.setDestinationTab"
      [title]="'storages:destinations.setDestination' | i18next"
      [valid]="
        !bucketInfoLoading() && (needsS3CompatibilityCheck ? isS3CompatibleChecked() && destinationForm.valid : destinationForm.valid)
      "
      (nextButtonClicked)="finalValidate()">
      <mbs-set-destination-step
        [bucketTypeName]="bucketTypeName"
        [companiesLocked]="!!lockedCompany"
        [compatibleError]="compatibleError()"
        [createNew]="createNewControl"
        [error]="credentialsError"
        [form]="destinationForm"
        [hideCompanies]="!!companyIds?.length"
        [isDraftAccount]="!useExistingAccountControl.value"
        [selectedCompanyIds]="accountScopeCompanyIds"
        [storageAccount]="$any(wizardForm.get('storageAccount')?.value)"
        (bucketLoadingChanged)="bucketInfoLoading.set($event)"
        (currentBucketChanged)="currentBucket = $event"
        (reportIssue)="reportIssue()"
        (tryAgain)="tryAgain()"></mbs-set-destination-step>
    </mbs-wizard-step>
  }

  @if (showS3AdditionalOptions() && !useExistingAccountControl.value) {
    <mbs-wizard-step
      [title]="'storages:addStorageAccountWizard.advancedSettingsStep.title' | i18next"
      [valid]="s3CompatibleOptionsStepValid"
      (nextButtonClicked)="validateCredentials(true)">
      <mbs-s3-compatible-advanced-settings-step
        [error]="isEditS3CompatibleOptions ? credentialsError : null"
        [form]="s3CompatibleForm"
        [isNativeMultipartControlShown]="isNativeMultipartControlShown()">
      </mbs-s3-compatible-advanced-settings-step>
    </mbs-wizard-step>
  }

  @if (isMBSIamRole() && !useExistingAccountControl.value) {
    <mbs-wizard-step
      [e2eLocator]="e2eLocators.amazonAdvancedSettingsTab"
      [title]="'storages:addStorageAccountWizard.advancedSettingsStep.title' | i18next"
      [valid]="true">
      <mbs-amazon-advanced-settings-step
        [mode]="mode"
        [wizardForm]="wizardForm"></mbs-amazon-advanced-settings-step>
    </mbs-wizard-step>
  }

  <mbs-wizard-step
    [e2eLocator]="e2eLocators.summaryTab"
    [title]="'shared:common.summary' | i18next"
    [valid]="true">
    <mbs-summary-step
      [currentBucket]="currentBucket"
      [error]="saveError"
      [formValue]="wizardForm?.value"
      [mode]="mode"
      [s3AdditionalOptionsShown]="showS3AdditionalOptions()"
      [useExistingAccount]="useExistingAccountControl.value"></mbs-summary-step>
  </mbs-wizard-step>
</mbs-wizard>
